import { alpha } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()(theme => ({
  root: {
    '&&': {
      display: 'grid',
      gridTemplateColumns: '1fr max-content',
      gridTemplateRows: '30px 1fr',
      justifyContent: 'space-between',
      width: '100%',
      minHeight: 150,

      padding: theme.spacing(4, 4.5),

      [theme.breakpoints.down('md')]: {
        padding: theme.spacing(2, 4.5, 4),
        minHeight: 100,
        maxWidth: '100%',
      },
    },
  },

  top: {
    display: 'flex',
    justifyContent: 'space-between',
    columnGap: theme.spacing(2),
    minHeight: 30,

    [theme.breakpoints.down('md')]: {
      alignItems: 'center',
    },
  },

  label: {
    fontWeight: 600,
    color: alpha(theme.palette.text.primary, 0.6),
    alignSelf: 'center',

    [theme.breakpoints.down('md')]: {
      alignSelf: 'auto',
    },
  },

  amount: {
    gridRow: 2,
    gridColumn: '1 / span 2',
    alignSelf: 'flex-end',
  },
}));
